import { BaseRecord } from "./BaseRecord";

export class Business extends BaseRecord<number> {
    public name: string;
    public incorporationDate!: Date;
    public registrationNo!: string;

    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.incorporationDate = new Date();
        this.registrationNo = "";
    }
}
